import {registerPlugin} from '@capacitor/core';

export type AnalyticsConsentStatus = 'unknown' | 'required' | 'notRequired' | 'obtained';

export interface AnalyticsConsentResult {
  status: AnalyticsConsentStatus;
}

export interface AnalyticsConsentPlugin {
  requestConsentStatus(): Promise<AnalyticsConsentResult>;
}

export const AnalyticsConsent = registerPlugin<AnalyticsConsentPlugin>('AnalyticsConsent');
